module.exports = __webpack_public_path__ + "img/烟花2.c89da6e4.gif";